import { render, staticRenderFns } from "./search_list.vue?vue&type=template&id=b497193c&scoped=true"
import script from "./search_list.vue?vue&type=script&lang=js"
export * from "./search_list.vue?vue&type=script&lang=js"
import style0 from "./search_list.vue?vue&type=style&index=0&id=b497193c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b497193c",
  null
  
)

export default component.exports